<template>
  <div class='coursework-viewer' :class="currentMedia && currentMedia.comments_path && show_comments ? 'state-comment' : 'state-preview'">

    <!-- HEADER -->
    <header-bar :navigation="navigation" :class="{'is-visible': !show_full_view && !show_comments}"/>

    <!-- FOOTER -->
    <footer-bar :has-carousel="hasCarousel" :author="author" :work="work" :media="currentMedia" @mouseover.native="footer_active = true" @mouseleave.native="footer_active = false"
                @toggleFullView="toggleFullView" @toggleDescription="toggleDescription" @toggleCarousel="toggleCarousel" @showShareModal="showShareModal"
                @toggleComments="toggleComments" @toggleFavorite="toggleFavorite" @showViewer="showViewer" :class="{'is-visible': !show_full_view}"/>


    <!-- MAIN VIEWER -->
    <div class='coursework-viewer__main'>
      <div class='coursework-viewer__main_wrapper'>
        <div class='coursework-viewer__tour1-target'></div>

        <!-- INLINE HEADER -->
        <div class='coursework-viewer__main_header'>
          <slot name="inline-header"></slot>

          <div class='course-page-header__breadcrumb' v-if="!mobileView && !show_full_view && navigation.referrer">
            <a href="javascript:;" class='inline-block-link--light rel' @click="goBack">
              <i class='kf kf-back-arrow'></i>
              <span>{{navigation.referrer.title}}</span>
            </a>
          </div>
        </div>

        <!-- MEDIA AREA -->
        <slider :subject="work.type" :navigation="navigation" :media="media" :refresh="show_comments" @ready="setInitialView" @navChanged="bindData" @slideChanged="setCurrentIndex"></slider>

        <!-- INLINE FOOTER -->
        <div class='coursework-viewer__main_footer'>

        </div>
      </div>

      <!-- SIDE PANEL HOLDER -->
      <div class='coursework-viewer__panel-wrapper'>

        <!-- MOBILE BUTTONS -->
        <!-- Note: This was originally inside the comment-panel but it doesn't belong there -->
        <div class='coursework-viewer__comment-panel' v-if="mobileView">
          <div class='coursework-viewer__comment-panel_mobile-btn-group'>
            <a href="javascript:" class='coursework-viewer__comment-panel_mobile-btn' v-if="currentMedia && currentMedia.comments_path" @click="showCommentModal">
              <i class='kf kf-comment-add'></i>
            </a>
            <a href="javascript:" class='coursework-viewer__comment-panel_mobile-btn' v-if="work.favouritable" @click="toggleFavorite">
              <i class='kf kf-heart-outline'></i>
            </a>
            <a href="javascript:" class='coursework-viewer__comment-panel_mobile-btn' v-if="work.shareable" @click="showShareModal">
              <i class='kf kf-share'></i>
            </a>
          </div>
        </div>

        <!-- COMMENT PANEL -->
        <comment-panel v-if="currentMedia && currentMedia.comments_path" @hideCommentModal="show_comment_modal = false" @commentCountChanged="commentCountChanged"
                       :is_open="show_comments || mobileView" :mobile_view="mobileView" :media="currentMedia" :current_user="current_user" :show_comment_modal="show_comment_modal"/>
      </div>

    </div>

    <!-- DESCRIPTION PANEL -->
    <description-panel :author="author" :work="work" :media="media" @toggleDescription="toggleDescription" :class="{'is-open': show_description}"/>

    <!-- CAROUSEL -->
    <carousel :navigation="navigation" :is_open="show_carousel" @mouseover.native="footer_active = true" @mouseleave.native="footer_active = false"
              @toggleCarousel="toggleCarousel" @navChanged="bindData" :class="{'is-open': show_carousel}" v-focus="!show_carousel"/>

  </div>
</template>

<script>
  import headerBar from './header-bar.vue'
  import slider from './slider.vue'
  import footerBar from './footer-bar.vue'
  import descriptionPanel from './description-panel.vue'
  import commentPanel from './comment-panel.vue'
  import carousel from './carousel.vue'
  import LoginModal from './../../login-modal';
  export default {
    props: {
      args: Object
    },
    components: {
      headerBar,
      slider,
      footerBar,
      descriptionPanel,
      commentPanel,
      carousel
    },
    data() {
      return {
        current_user: {},
        author: {},
        work: {},
        navigation: {},
        media: [],
        comments: {},
        window_width: $(window).width(),
        show_full_view: false,
        show_description: false,
        show_comments: false,
        show_comment_modal: false,
        show_carousel: false,
        footer_active: false,
        footer_timeout: null,
        current_index: 0
      }
    },
    computed: {
      currentMedia() {
        return this.media[this.current_index];
      },
      hasCarousel() {
        return !_.isEmpty(this.navigation.browse_url);
      },
      mobileView() {
        return this.window_width < Kadenze.UIUtil.mobileBreakPoint()
      }
    },
    watch: {
      footer_active() {
        if (this.footer_active) {
          clearTimeout(this.footer_timeout)
        } else {
          this.footer_timeout = setTimeout(() => {
            this.show_carousel = false;
          }, 500)
        }
      }
    },
    methods: {
      loginOrRegister() {
        //TODO: Set avatar
        let deferred = $.Deferred();
        if (this.current_user.status === 'public') {
          let $el = $('#js-course-enroll-modal--authenticate');
          let args = {
            onLogin: (response) => {
              this.current_user.status = 'member';
              deferred.resolve();
              $el.modal('hide');
            },
            onRegister: (response) => {
              Kadenze.Analytics.track('student_ui', 'enrollment_started', { source_medium: 'portfolio_viewer' });
              this.current_user.status = 'member';
              deferred.resolve();
              $el.modal('hide');
            }
          };

          let vm = new LoginModal(args);
          ko.cleanNode($el[0]);
          ko.applyBindingsWithValidation(vm, $el[0], _.extend({}, Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS, {insertMessages: false}));

          $el.on('shown.bs.modal', function(){
            vm.initSSOEvents();
          });
          $el.modal('show');
        } else {
          deferred.resolve();
        }
        return deferred;
      },
      refreshURL() {
        //TODO: Add some more logic herre to conditionally do pushState vs replaceState
        history.pushState($.pjax.state, null, this.work.url);
      },
      bindData(data) {
        this.current_user = data.current_user;
        this.author = data.author;
        this.media = this.setInitialSlide(data.media);
        this.navigation = data.navigation;
        this.work = data.work;
      },
      setInitialSlide(media) {
        let media_id = Kadenze.Util.getParameterByName('slide');
        let slide_index = 0;

        if (!isNaN(parseInt(media_id))) {
          media_id = parseInt(media_id);

          slide_index = _.findIndex(media, (item) => {
            return item.id === media_id;
          });

          if (slide_index > 0) {
            media[slide_index].initial_slide = true;
          }
        }

        return media;
      },
      setInitialView() {
        const view = Kadenze.Util.getParameterByName('view');
        if (view === 'comment') {
          this.show_comments = true
        }

        this.refreshURL();
      },
      goBack() {
        if (!_.isEmpty(this.navigation.referrer)) {
          if (_.isFunction(this.navigation.referrer.action)) {
            this.navigation.referrer.action();
            window.history.back();
            this.$destroy();
          } else {
            window.location = this.navigation.referrer.action
          }
        }
      },
      toggleFullView() {
        this.show_full_view = !this.show_full_view
      },
      toggleDescription() {
        this.show_description = !this.show_description
      },
      toggleComments() {
        this.show_comments = !this.show_comments
      },
      toggleFavorite() {
        //TODO
      },
      toggleCarousel() {
        this.show_carousel = !this.show_carousel
      },
      showViewer() {
        this.show_comments = false
      },
      showShareModal() {
        let params = {
          modal_title: `Share this ${this.work.type.toLowerCase()}`,
          shareableObj: this.work.shareable,
          emailShareCb: (work, emails) => this.work.shareable.email_callback({work: work, emails: emails})
        };
        let modal = new Kadenze.ShareModal(params);
        modal.show();
      },
      showCommentModal() {
        this.loginOrRegister().done(() => {
          this.show_comment_modal = true
        })
      },
      setCurrentIndex(index) {
        this.current_index = index
      },
      commentCountChanged() {
        const total = _.reduce(this.media, function(memo, media){ return media.comment_count + memo; }, 0);
        this.$emit('commentCountChanged', total)
      }
    },
    created() {
      this.bindData(this.args)
    },
    mounted() {
      $(window).resize(() => {
        this.window_width = $(window).width();
      });
    }
  }
</script>
